import React from 'react';
import { ReactComponent as Icon } from './../../../../asset/icons/female.svg';

const IconFemale = () => {
  return <Icon></Icon>;
};

export default IconFemale;
